import React from "react";

import styles from "./gray-icon-notification.module.scss";
interface GrayIconNotificationPropTypes {
  icon: string;
  text: string;
  altText: string;
}

const cssClassName = "gray-icon-notification";

export const GrayIconNotification = ({
  icon,
  text,
  altText,
}: GrayIconNotificationPropTypes) => {
  return (
    <div className={styles[cssClassName]}>
      <img
        className={styles[`${cssClassName}__icon`]}
        src={icon}
        alt={altText}
      />
      <span className={styles[`${cssClassName}__text`]}>{text}</span>
    </div>
  );
};
